import { Check, Copy, ExternalLink } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import { Button } from '@sara/ui/components/button';
import { Input } from '@sara/ui/components/input';
import { useCopyToClipboard } from '../../../../hooks/useCopyToClipboard';
import { useOrgSlug } from '../../../auth';

interface CreateInterviewSuccessProps {
  candidateName: string;
  interviewUrl: string;
  interviewInviteId: string;
  onClose: () => void;
}

function CreateInterviewSuccess({
  candidateName,
  interviewUrl,
  interviewInviteId,
  onClose,
}: CreateInterviewSuccessProps) {
  const { copied, copy } = useCopyToClipboard();
  const orgSlug = useOrgSlug();

  return (
    <div className="space-y-6">
      <div className="flex flex-col items-center gap-3 py-2">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-success-muted ring-1 ring-inset ring-success/20">
          <Check className="h-5 w-5 text-success" strokeWidth={1.6} />
        </div>
        <div className="text-center">
          <p className="font-display text-lg font-medium text-foreground">
            Invite ready for {candidateName}
          </p>
          <p className="mt-1 text-sm text-muted-foreground">
            Copy the link below and share it with the candidate to begin the interview.
          </p>
        </div>
      </div>

      <div className="flex gap-2">
        <Input readOnly value={interviewUrl} className="font-mono text-xs" />
        <Button
          variant="outline"
          size="icon"
          className="shrink-0"
          onClick={() => copy(interviewUrl)}
        >
          {copied ? (
            <Check className="h-4 w-4 text-success" strokeWidth={1.6} />
          ) : (
            <Copy className="h-4 w-4" strokeWidth={1.6} />
          )}
        </Button>
      </div>

      <div className="flex justify-end gap-2">
        <Button variant="outline" shape="pill" size="sm" onClick={onClose}>
          Close
        </Button>
        <Button asChild variant="tinted" shape="pill" size="sm" className="gap-1.5">
          <Link
            to="/orgs/$orgSlug/sessions/$interviewId"
            params={{ orgSlug, interviewId: interviewInviteId }}
            onClick={onClose}
          >
            View details
            <ExternalLink className="ml-1 h-3.5 w-3.5" strokeWidth={1.6} />
          </Link>
        </Button>
      </div>
    </div>
  );
}

export { CreateInterviewSuccess };
